
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/free-coaching-call",
      function () {
        return require("private-next-pages/free-coaching-call.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/free-coaching-call"])
      });
    }
  